import { Box, Chip, Typography } from "@mui/material";

interface Props {
  items: string[];
  empty?: string;
}

/**
 * Vertical stack of outlined "type" chips (Source/Target/Frequency cells).
 * Chips truncate to the column width with an ellipsis; the full text is shown
 * on hover (title). Mirrors the chip style used in the Integration Details header.
 */
export default function TypeChipList({ items, empty = "—" }: Props) {
  if (!items.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        {empty}
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 0.5,
        minWidth: 0,
        maxWidth: "100%",
      }}
    >
      {items.map((item, i) => (
        <Chip
          key={`${item}-${i}`}
          label={item}
          title={item}
          size="small"
          variant="outlined"
          sx={{ maxWidth: "100%" }}
        />
      ))}
    </Box>
  );
}
